/**
 * Маркбэйс id — единые тексты кнопки «Единый аккаунт» и пояснения (SSOT для auth-widget).
 * CDN: https://auth.markbase.ru/sdk/unifiedAccountContent.js
 */

export const UNIFIED_ACCOUNT_LABELS = {
  primary: 'Единый аккаунт',
  secondary: 'Маркбэйс id',
};

export const UNIFIED_ACCOUNT_INFO = {
  title: 'Единый аккаунт Маркбэйс',
  intro:
    'Маркбэйс id — единый защищённый профиль для всех сервисов экосистемы: магазины, кабинеты, модули и партнёрские сайты. Один вход вместо отдельных паролей на каждом ресурсе.',
  benefits: [
    {
      title: 'Защита персональных данных',
      text: 'Согласия, политики конфиденциальности и доступ к персональным данным управляются централизованно в соответствии с 152-ФЗ.',
    },
    {
      title: 'Удобство использования',
      text: 'Один вход для всех сайтов и приложений экосистемы — не нужно запоминать отдельный пароль для каждого сервиса.',
    },
    {
      title: 'Безопасное хранение и защита',
      text: 'Пароли и сессии защищены на стороне UAM: шифрование, контроль устройств, капча и ограничение попыток входа.',
    },
    {
      title: 'Контроль и управление в одном месте',
      text: 'Профиль, компании, уведомления, устройства и согласия — в личном кабинете auth.markbase.ru.',
    },
  ],
  infoAriaLabel: 'Подробнее об едином аккаунте Маркбэйс id',
};
